import { BADGE_STYLE } from "@/lib/constants";
import { Award } from "lucide-react";

export default function BadgePill({ tier = "Bronze", testId }) {
  const style = BADGE_STYLE[tier] || BADGE_STYLE.Bronze;
  return (
    <span
      className="badge-tier inline-flex items-center gap-1"
      data-testid={testId}
      style={{ background: style.bg, color: style.color }}
    >
      <Award className="w-3 h-3" /> {tier}
    </span>
  );
}
